import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from '../../../helpers'

const CommissionSummary = ({
  totalFee,
  canWithdraw,
  handleOpenWithdrawalModal,
  setShowBankListModal
}) => {
  return (
    <div className="totalbayar">
      <h2 className="ringkasan">Ringkasan Komisi</h2>
      <div className="isi-total">
        <p className="totalharga">Total Komisi</p>
        <p className="total">{formatPrice(totalFee, 'Rp.')}</p>
      </div>
      <div className="btn-bayar" style={{ marginTop: '15px' }}>
        <button
          type="button"
          onClick={handleOpenWithdrawalModal}
          disabled={!canWithdraw}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '6px',
            border: 'none',
            cursor: canWithdraw ? 'pointer' : 'not-allowed',
            backgroundColor: canWithdraw ? '#00a651' : '#ccc',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '1em',
            outline: 'none',
            transition: 'all 0.2s ease'
          }}
        >
          Ajukan penarikan
        </button>
      </div>
      {!canWithdraw && (
        <p style={{ color: '#dc3545', fontSize: '0.8em', textAlign: 'center', marginTop: '8px', marginBottom: 0 }}>
          * Minimal penarikan komisi Rp 50.000
        </p>
      )}
      <div style={{ textAlign: 'center', marginTop: '14px' }}>
        <button
          type="button"
          onClick={() => setShowBankListModal(true)}
          style={{
            background: 'none',
            border: 'none',
            color: '#00a651',
            fontSize: '0.9em',
            fontWeight: '600',
            textDecoration: 'underline',
            cursor: 'pointer',
            outline: 'none'
          }}
        >
          Daftar Rekening
        </button>
      </div>
    </div>
  )
}

CommissionSummary.propTypes = {
  totalFee: PropTypes.number.isRequired,
  canWithdraw: PropTypes.bool.isRequired,
  handleOpenWithdrawalModal: PropTypes.func.isRequired,
  setShowBankListModal: PropTypes.func.isRequired
}

export default CommissionSummary
